// check is window object exist for correct tests run
export const getIsMobile = () => (
  typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 600px)').matches
    : false
);
